import React from 'react';
import { Link } from 'react-router-dom';
import { HiMail } from 'react-icons/hi';
import { FaXTwitter, FaLinkedinIn, FaGithub } from 'react-icons/fa6';
import './Footer.css';

const footerLinks = {
  Product: [
    { label: 'Features', path: '/features' },
    { label: 'API & SDKs', path: '/features#api' },
    { label: 'Integrations', path: '/features#integrations' },
    { label: 'Pricing', path: '/#pricing' },
  ],
  Company: [
    { label: 'About', path: '/about' },
    { label: 'Team', path: '/team' },
    { label: 'Contact', path: '/contact' },
    { label: 'FAQ', path: '/faq' },
  ],
  Legal: [
    { label: 'Privacy Policy', path: '/privacy' },
    { label: 'Terms of Service', path: '/terms' },
  ],
};

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <span className="gradient-text">AI</span>Scaler
            </Link>
            <p className="footer__desc">
              AI-powered platform to upscale and enhance images, videos, and documents automatically.
            </p>
            <div className="footer__socials">
              <a href="mailto:info@aiscaler.app" aria-label="Email" className="footer__social"><HiMail /></a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title} className="footer__col">
              <h4 className="footer__col-title">{title}</h4>
              {links.map(({ label, path }) => (
                <Link key={label} to={path} className="footer__link">{label}</Link>
              ))}
            </div>
          ))}
        </div>

        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} AIScaler. All rights reserved.</p>
          <p>
            <a href="mailto:info@aiscaler.app" className="footer__bottom-link">info@aiscaler.app</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
